export default "__VITE_ASSET__DZXTIaI4__"